import React from 'react'
import styles from './styles.module.css'
import { navigate, Link as GatsbyLink } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHotmartEvent } from '../../hooks/useHotmartEvent'

const isGoogleDocs = href => href.includes('docs.google.com')

const ExternalLink = ({ href, icon = ['fas', 'external-link'], children }) => {
  const { sendHotmartEvent } = useHotmartEvent()

  const sendDHEvent = event => {
    if (!isGoogleDocs(event.currentTarget.href)) {
      return void 0
    }
  
    const evtData = {name:'copy_google_spreadsheets', url: event.currentTarget.href}

    sendHotmartEvent({ 
      entity: 'tracking',
      action: 'download',
      event: evtData,
    })
  
  }

  return (
    <a className={styles.link} href={href} data-testid="external-link" target="_blank" rel="noreferrer" onClick={event => sendDHEvent(event)}>
      {children} <FontAwesomeIcon data-testid="link-icon" icon={icon} />
    </a>
  )
}

const InternalLink = ({ href, icon = ['fas', 'link'], children }) => {
  const url = process.env.GATSBY_PATH_PREFIX ? href.replace(`/${process.env.GATSBY_PATH_PREFIX}`, '') : href

  return (
    <GatsbyLink to={url} data-testid="internal-link" className={styles.link}>
      {children} <FontAwesomeIcon data-testid="link-icon" icon={icon} />
    </GatsbyLink>
  )
}

const AnchorLink = ({ children, href, ...rest }) => {
  return (
    <a
      href="#"
      onClick={event => {
        event.preventDefault()
        navigate(href)
      }}
      data-testid="anchor-link"
      to={href}
      {...rest}
    >
      {children}
    </a>
  )
}

const Link = ({ children, href = '', ...rest }) => {
  const isExternal = /https?:\/\//.test(href)
  const isAnchorLink = href.startsWith('#')
  let LinkElement = InternalLink

  if (isAnchorLink) {
    LinkElement = AnchorLink
  }

  if (isExternal) {
    LinkElement = ExternalLink
  }

  return (
    <LinkElement href={href} {...rest}>
      {children}
    </LinkElement>
  )
}

export default Link
